<template lang="pug">
#myApplication
  .formSearch
    search(ref="approveSearch" showStatusSelect :showPrjSelect="!isProject"  @change="handleSearch")
  .midd(v-loading="loading" element-loading-text="数据加载中")
    el-table(ref="multipleTable"  highlight-current-row size="small" border height="100%" :data="tableData")
      el-table-column(type="index" label="编号" align="center" width="60" )
      el-table-column(label="状态" sortable prop="status" width="80px" align="center" v-slot="{row}")
        span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
      el-table-column(label="流程类型" sortable align="center" prop="flowType" min-width="80px")
      el-table-column(label="标题" sortable prop="title" min-width="120px" v-slot="{row}")
        el-link(type="primary" @click="cellClick(row)")
          span(class="tabLinkSpan" :title='row.title') {{ row.title }}
      el-table-column(label="内容" prop="content" min-width="100px" show-overflow-tooltip)
      el-table-column(label="申请人" prop="flowInstanceOwnerName" align="center" min-width="100px")
      el-table-column(label="开始时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip)
      el-table-column(label="当前审批人" align="center" prop="currentNodeAssigneeName" show-overflow-tooltip)
      el-table-column(label="上个审批节点" align="center" prop="lastNodeName" show-overflow-tooltip)
      el-table-column(label="备注" align="center" prop="remark"  min-width="140px" show-overflow-tooltip)
      el-table-column(label="操作"  min-width="110px" v-slot="{row}")
        el-button(type="text" v-if="row.status === 2" @click.stop="termination(row)") 终止
        el-button(type="text" v-if="withdrawBoolean(row)" @click.stop="handleWithdrawBtnClick(row)") 撤回
        el-button(type="text" v-if="row.status !== 9" @click.stop="clickChange(row, 'view')") 查看
        el-button(type="text" v-if="row.status === 9 " @click.stop="clickChange(row,'draft')") 编辑
        el-button(type="text" v-if="row.status === 0 || row.status === 3" @click.stop="clickChange(row,'again')") 重新发起
        el-button(type="text" v-if="row.status === 9 " @click.stop="delDraftFlow(row)") 删除
        el-dropdown(v-if="row.status === 1 && row.printTemplateFileId" @command="handleDownClick(row, $event)")
            el-button(type="text") 成果文件
              i(class="el-icon-arrow-down el-icon--right")
            el-dropdown-menu(slot="dropdown")
              el-dropdown-item(command="down") 下载
              el-dropdown-item(command="recreate") 重新生成
  .page
    el-pagination(:current-page.sync="page.pageNum"
      :page-size="page.pageSize"
      :layout="page.pageLayout"
      :total="page.totalCount"
      v-if="page.totalCount > 0"
      :page-sizes="[10, 20, 50, 100]"
      size="small"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange")
</template>

<script>
import { mapState } from "vuex";

import search from "../config/search.vue";
import flowService from "@/CommonDP/service/flow-service";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { getDownloadDesignTemplateInfo } from "@/CommonDP/service/listFlow-service";
import { downloadFileShowPrompt, decodeFileName } from "@/CommonDP/utils";
export default {
  components: { search },
  props: {
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes, prev, pager, next, jumper"
      },
      viewMode: 0, // 审批1 查看2
      approveType: "",
      statusName: getStatusName
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    searchFormParams() {
      if (this.isProject) {
        return {
          ...this.$refs.approveSearch.getForm(),
          prjId: this.prjInfo?.prjId
        };
      } else {
        return this.$refs.approveSearch.getForm();
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSearch(form) {
      this.page.pageNum = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const res = await flowService.mySubmit(this.searchFormParams, this.page.pageNum, this.page.pageSize);
      this.tableData = res.data || [];
      this.loading = false;
      this.page.pageNum = res.pageIndex;
      this.page.totalCount = res.totalCount;
    },

    updateTable() {
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    async clickChange(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        try {
          await openFlow(data);
        } catch (error) {
          console.log(error);
        }
        this.getList();
      }
    },
    // 流程终止 自己 流程状态是 审批中
    async termination(row) {
      const form = Vue.observable({ remark: "", verify: false });
      const FContent = {
        render() {
          return (
            <div>
              <ElInput vModel={form.remark} size='mini' type='textarea' autosize={{ minRows: 2, maxRows: 6 }} show-word-limit placeholder='请输入终止原因' />
              {form.verify ? <div style='color:#ff0000;'>请输入终止原因</div> : undefined}
            </div>
          );
        }
      };
      await this.$msgbox({
        title: "终止流程",
        message: <FContent />,
        showCancelButton: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (!form.remark) form.verify = true;
            else {
              done();
            }
          } else {
            done();
          }
        }
      });
      const params = {
        flowInstanceId: row.flowInstanceId,
        remark: form.remark
      };
      await flowService.terminationFlowInstance(params);
      this.$success("流程终止成功");
      this.getList();
    },
    async delDraftFlow(row) {
      await this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      await flowService.delDraftFlow(row.businessType, row.businessId);
      this.getList();
    },
    reStartBoolean(row) {
      return row.status === 0 || row.status === 3;
    },
    withdrawBoolean(row) {
      return row.status === 2;
    },
    editBoolean(row) {
      return row.status === 9;
    },
    // 撤回
    handleWithdrawBtnClick(row) {
      this.$confirm(`您确定撤回当前流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const params = { flowInstanceId: row.flowInstanceId };
          await flowService.withdraw(params);
          this.$success("流程撤回成功");
          this.getList();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleDownClick(row, command) {
      switch (command) {
        case "down":
          this.downDesignFile(row);
          break;
        case "recreate":
          this.recreateDesignFile(row);
          break;
      }
    },

    async downDesignFile(item) {
      const response = await getDownloadDesignTemplateInfo(item.flowInstanceId);
      const fileName = decodeFileName(response.getHeaders()["content-disposition"]);
      downloadFileShowPrompt(fileName, response);
    },

    async recreateDesignFile(item) {
      await this.$confirm(`确认重新生成成果文件吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.$success("生成中请稍候，完成后将自动下载成果文件");
      const res = await flowService.recreateDesignFile(item.flowInstanceId);
      // this.$success("成果文件已生成，准备下载");
      item.printTemplateFileId = res.data?.fileId;
      item.printResultFileVersion = res.data?.fileVersion;
      this.downDesignFile(item);
    },
    cellClick(row) {
      const type = row.status !== 9 ? "view" : "draft";
      this.clickChange(row, type);
    }
  }
};
</script>

<style lang="scss" scoped>
#myApplication {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .approveSearch {
    padding: 10px 0;
  }

  .midd {
    flex: 1 1;
    overflow: hidden;
  }
}

.formSearch {
  margin-top: var(--middle-space);
}

.page {
  padding: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,
.type4 {
  border: 1px solid #10a667;
  background: rgba(16, 166, 103, 0.1);
  color: #10a667;
}

.type2 {
  border: 1px solid #ff7a00;
  background: rgba(255, 122, 0, 0.1);
  color: #ff7a00;
}

.type3 {
  border: 1px solid #60656b;
  background: rgba(96, 101, 107, 0.1);
  color: #60656b;
}

.type8 {
  border: 1px solid #9746e8;
  background: rgba(151, 70, 232, 0.1);
  color: #9746e8;
}

.type9 {
  border: 1px solid #2f8bf8;
  background: rgba(47, 139, 248, 0.1);
  color: #2f8bf8;
}

.type0 {
  border: 1px solid #ff4a4a;
  background: rgba(255, 74, 74, 0.1);
  color: #ff4a4a;
}
</style>
